
export function getCurrentBrand(): string {
    const hostname = window.location.hostname;

    // Normalize hostname by removing www. and converting to lowercase
    const host = hostname.replace("www.", "").toLowerCase();

    // This frontend always serves diyelectronicmech brand
    if (host.includes("diyelectronicmech")) return "diyelectronicmech";

    // Other domains (dev / localhost fallback)
    if (host.includes("diytruckmech")) return "diytruckmech";
    if (host.includes("diymotomech")) return "diymotomech";
    if (host.includes("diyatvmech")) return "diyatvmech";
    if (host.includes("diyappliancemech")) return "diyappliancemech";
    if (host.includes("diyhvacmech")) return "diyhvamech";
    if (host.includes("diy-mech")) return "diy-mech";
    if (host.includes("diycarmech")) return "diycarmech";

    // Default fallback for localhost dev
    return "diyelectronicmech";
}
